import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ReasonDialogProps {
  open: boolean;
  title: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
  onSave: () => void;
  isFromReceive?: boolean; // Optional prop to differentiate between Issue and Receive contexts
}

const SelectReasonPoup: React.FC<ReasonDialogProps> = ({
  open,
  title,
  label,
  value,
  onChange,
  onClose,
  onSave,
  isFromReceive = false, // Default to false if not provided
}) => {
  const { t: tStockTransfer } = useTranslation('stockTransfer_config');
  const isEmptyReason = !value || value.trim().length === 0;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: '14px', padding: '4px 0px' }
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ px: 1, borderBottom: '1px solid #E0E0E0' }}>
        <DialogTitle sx={{ fontWeight: 700, fontSize: '20px', p: 2 }}>
          {title}
        </DialogTitle>

        <IconButton
          onClick={onClose}
          sx={{
            marginRight: '8px',
            bgcolor: '#E0E0E0',
            width: 30,
            height: 30,
            '&:hover': { bgcolor: '#BDBDBD' }
          }}
        >
          <CloseIcon sx={{ fontSize: 17, color: '#757575' }} />
        </IconButton>
      </Box>

      <DialogContent sx={{ pt: 3 }}>
        <TextField
          fullWidth
          placeholder={tStockTransfer('Type Here...')}
          label={label}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '10px',
            }
          }}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          variant="outlined"
          fullWidth
          onClick={onClose}
          sx={{
            borderRadius: '10px',
            textTransform: 'none',
            fontWeight: 600,
            height: 46,
            bgcolor: '#F5F5F5',
            border: 'none',
            color: '#000',
            '&:hover': { bgcolor: '#EEEEEE', border: 'none' }
          }}
        >
          {tStockTransfer('Cancel')}
        </Button>

        <Button
          variant="contained"
          fullWidth
          onClick={onSave}
          sx={{
            borderRadius: '10px',
            textTransform: 'none',
            fontWeight: 600,
            height: 46,
            bgcolor: '#484848',
            '&:hover': { bgcolor: '#303030' }
          }}
          disabled={isFromReceive ? false : isEmptyReason}
        >
          {tStockTransfer('Save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelectReasonPoup;
